module.exports = __webpack_public_path__ + "static/media/pattern-dots.eed5abe6.svg";